document.addEventListener('DOMContentLoaded', function() {
  // 初始化时检查 Product Type
  toggleProductTypeSelect(getSelectedCaseTypeOp());
  
  const taxElement = document.querySelector('.product__tax');
  if (taxElement) {
      taxElement.innerHTML = '';
  }

  // 监听变化事件
  document.addEventListener('change', function(event) {
    // Device 变化时触发颜色更新
    if (event.target.name && event.target.name.includes("Device")) {
      var deviceValue = event.target.value;
      triggerDeviceUpdate(deviceValue);
     
    }
  });

  // =============================================
  // 触发设备更新事件
  // =============================================

  function triggerDeviceUpdate(deviceType) {
    // 更新 media-gallery 的 data-current-device 属性
    var gallery = document.querySelector('media-gallery');
    if (gallery) {
      gallery.dataset.currentDevice = deviceType;
      
      // 触发自定义事件，让 media-gallery 重新加载颜色
      gallery.dispatchEvent(new CustomEvent('deviceUpdated', {
        detail: { 
          device: deviceType
        }
      }));
    }
    
  }

  // =============================================
  // 原有的 toggle 函数
  // =============================================

  function toggleProductTypeSelect(caseType) {
    console.log(caseType)
    // 查找所有 fieldset 元素
    const fieldsets = document.querySelectorAll('fieldset');
    
    // 遍历 fieldset 找到包含 "Product" 的
    let productTypeFieldset;
    fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend .font-body-bold');
        if (legend && legend.textContent.includes('Product')) {
            productTypeFieldset = fieldset;
        }
    });
    // 查找提示信息元素
    var ProductInputs = document.querySelectorAll('input[name*="Product"]');
    if (caseType.toLowerCase().includes('essentique')) {
        if (ProductInputs.length > 0) {
            // 查找包含"unibody"值的input并点击（忽略大小写）
            for (var i = 0; i < ProductInputs.length; i++) {
                if (ProductInputs[i].value.toLowerCase().includes('unibody case')) {
                    ProductInputs[i].click();
                    break; // 找到第一个匹配项后退出循环
                }
            }
        }
    } else {
        if (ProductInputs.length > 0) {
            // 查找第一个不包含"unibody"值的input并点击（忽略大小写）
            for (var i = 0; i < ProductInputs.length; i++) {
                if (!ProductInputs[i].value.toLowerCase().includes('unibody case')) {
                    ProductInputs[i].click();
                    break;
                }
            }
        }
    }
  }

  function getSelectedCaseTypeOp() {
    var checked = document.querySelector('input[name*="Case"]:checked');
    return checked ? checked.value : '';
  }

  function getSelectedDevice() {
    var checked = document.querySelector('input[name*="Device"]:checked');
    return checked ? checked.value : '';
  }

  // =============================================
  // 暴露全局 API
  // =============================================

  window.__productSwitcher = {
    triggerDeviceUpdate: triggerDeviceUpdate,
    getSelectedDevice: getSelectedDevice,
    toggleProductTypeSelect: toggleProductTypeSelect
  };

});